module.exports = __webpack_public_path__ + "media/images/pear_22-50be3be5ae65f98481269174d67b47e9.jpg";